import { useTranslation } from 'react-i18next';



import { NavBar } from '@/components/NavBar';
import PageWithTOC, { Section } from '@/components/PageWithTOC';


const getCookiePolicySections = (t: any): Section[] => [
  {
    id: 'introduction',
    title: '',
    content: (
      <p className="text-base font-normal text-white">{t('policies.cookiePolicy.introduction')}</p>
    ),
  },
  {
    id: 'introduction-detail',
    title: '',
    content: (
      <p className="text-base font-normal text-white">
        {t('policies.cookiePolicy.introductionDetail')}
      </p>
    ),
  },
  {
    id: 'tracking-technologies',
    title: t('policies.cookiePolicy.trackingTechnologies'),
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <div>
          <p>
            <span className="font-semibold">{t('policies.cookiePolicy.cookies')}:</span>{' '}
            {t('policies.cookiePolicy.cookiesDescription')}
          </p>
        </div>
        <div>
          <p>
            <span className="font-semibold">{t('policies.cookiePolicy.sdks')}:</span>{' '}
            {t('policies.cookiePolicy.sdksDescription')}
          </p>
        </div>
        <div>
          <p>
            <span className="font-semibold">{t('policies.cookiePolicy.pixels')}:</span>{' '}
            {t('policies.cookiePolicy.pixelsDescription')}
          </p>
        </div>
        <div>
          <p>
            <span className="font-semibold">{t('policies.cookiePolicy.localStorage')}:</span>{' '}
            {t('policies.cookiePolicy.localStorageDescription')}
          </p>
        </div>
      </div>
    ),
  },
  {
    id: 'categories',
    title: t('policies.cookiePolicy.categories'),
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <p>{t('policies.cookiePolicy.categoriesDescription')}</p>
      </div>
    ),
  },
  {
    id: 'necessary',
    title: t('policies.cookiePolicy.necessary'),
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <p>{t('policies.cookiePolicy.necessaryDescription')}</p>
        <ul className="ml-6 list-disc space-y-2">
          {t('policies.cookiePolicy.necessaryPurposes', { returnObjects: true }).map(
            (purpose: string, index: number) => (
              <li key={index}>{purpose}</li>
            ),
          )}
        </ul>
        <p>
          {t('policies.cookiePolicy.necessaryNote')}{' '}
          <span className="font-semibold">{t('policies.cookiePolicy.necessaryExamples')}</span>
        </p>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-[#dddddd]">
            <thead>
              <tr>
                <th className="border border-[#dddddd] p-2 text-left">Name</th>
                <th className="border border-[#dddddd] p-2 text-left">Purpose</th>
                <th className="border border-[#dddddd] p-2 text-left">Duration</th>
                <th className="border border-[#dddddd] p-2 text-left">Set by</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-[#dddddd] p-2">accessproxy_session</td>
                <td className="border border-[#dddddd] p-2">
                  Access proxy session management; User authentication
                </td>
                <td className="border border-[#dddddd] p-2">1 months</td>
                <td className="border border-[#dddddd] p-2">CodeFlicker</td>
              </tr>
              <tr>
                <td className="border border-[#dddddd] p-2">ide_auth_token</td>
                <td className="border border-[#dddddd] p-2">
                  IDE authentication token; User login state management
                </td>
                <td className="border border-[#dddddd] p-2">1 months</td>
                <td className="border border-[#dddddd] p-2">CodeFlicker</td>
              </tr>
              <tr>
                <td className="border border-[#dddddd] p-2">JSESSIONID</td>
                <td className="border border-[#dddddd] p-2">
                  Java session management; Maintaining user session state
                </td>
                <td className="border border-[#dddddd] p-2">Session</td>
                <td className="border border-[#dddddd] p-2">CodeFlicker</td>
              </tr>
              <tr>
                <td className="border border-[#dddddd] p-2">ktrace-context</td>
                <td className="border border-[#dddddd] p-2">
                  Request tracing; Performance monitoring and debugging
                </td>
                <td className="border border-[#dddddd] p-2">Session</td>
                <td className="border border-[#dddddd] p-2">CodeFlicker</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    ),
  },
  {
    id: 'Advertising and marketing',
    title: t('policies.cookiePolicy.advertising'),
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <p>{t('policies.cookiePolicy.advertisingDescription')}</p>
        <p>
          <span className="font-semibold">{t('policies.cookiePolicy.advertisingExamples')}</span>
        </p>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-[#dddddd]">
            <thead>
              <tr>
                <th className="border border-[#dddddd] p-2 text-left">Cookie</th>
                <th className="border border-[#dddddd] p-2 text-left">Purpose</th>
                <th className="border border-[#dddddd] p-2 text-left">Duration</th>
                <th className="border border-[#dddddd] p-2 text-left">Set by</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-[#dddddd] p-2">guest_id</td>
                <td className="border border-[#dddddd] p-2">
                  Unique ID for unauthenticated users; tracks behaviors for personalized
                  recommendations and ad preference collection.
                </td>
                <td className="border border-[#dddddd] p-2">Typically 1 year</td>
                <td className="border border-[#dddddd] p-2">Twitter</td>
              </tr>
              <tr>
                <td className="border border-[#dddddd] p-2">guest_id_ads</td>
                <td className="border border-[#dddddd] p-2">
                  Tracks ad interactions of unauthenticated users; optimizes ad delivery and enables
                  cross-device ad targeting.
                </td>
                <td className="border border-[#dddddd] p-2">Typically 1 year</td>
                <td className="border border-[#dddddd] p-2">Twitter</td>
              </tr>
              <tr>
                <td className="border border-[#dddddd] p-2">guest_id_marketing</td>
                <td className="border border-[#dddddd] p-2">
                  Monitors marketing initiative engagement; segments users for customized marketing
                  and supports privacy compliance.
                </td>
                <td className="border border-[#dddddd] p-2">Typically 1 year</td>
                <td className="border border-[#dddddd] p-2">Twitter</td>
              </tr>
              <tr>
                <td className="border border-[#dddddd] p-2">personalization_id</td>
                <td className="border border-[#dddddd] p-2">
                  Powers content/ad personalization; builds user interest profiles and syncs
                  settings across devices.
                </td>
                <td className="border border-[#dddddd] p-2">
                  Persistent (varies by user activity)
                </td>
                <td className="border border-[#dddddd] p-2">Twitter</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    ),
  },
  {
    id: 'manage-technologies',
    title: t('policies.cookiePolicy.manage'),
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <p>
          <span className="font-semibold">Preferences:</span>{' '}
          {t('policies.cookiePolicy.manageDescription')}
        </p>
        <ul className="ml-6 list-disc space-y-2">
          {t('policies.cookiePolicy.manageOptions', { returnObjects: true }).map(
            (option: string, index: number) => (
              <li key={index}>{option}</li>
            ),
          )}
        </ul>
        <p>{t('policies.cookiePolicy.manageNote')}</p>
        <div className="space-y-2">
          <p>
            Google Chrome:{' '}
            <a href={t('policies.cookiePolicy.browserLinks.chrome')} className="underline">
              {t('policies.cookiePolicy.browserLinks.chrome')}
            </a>
          </p>
          <p>
            Safari:{' '}
            <a href={t('policies.cookiePolicy.browserLinks.safari')} className="underline">
              {t('policies.cookiePolicy.browserLinks.safari')}
            </a>
          </p>
          <p>
            Internet Explorer:{' '}
            <a href={t('policies.cookiePolicy.browserLinks.ie')} className="underline">
              {t('policies.cookiePolicy.browserLinks.ie')}
            </a>
          </p>
          <p>
            Edge:{' '}
            <a href={t('policies.cookiePolicy.browserLinks.edge')} className="underline">
              {t('policies.cookiePolicy.browserLinks.edge')}
            </a>
          </p>
          <p>
            Firefox:{' '}
            <a href={t('policies.cookiePolicy.browserLinks.firefox')} className="underline">
              {t('policies.cookiePolicy.browserLinks.firefox')}
            </a>
          </p>
        </div>
        <p>
          <span className="font-semibold">{t('policies.cookiePolicy.removing')}:</span>{' '}
          {t('policies.cookiePolicy.removingDescription')}
        </p>
      </div>
    ),
  },
  {
    id: 'changes',
    title: t('policies.cookiePolicy.changes'),
    content: (
      <div className="text-base font-normal text-white">
        <p>{t('policies.cookiePolicy.changesDescription')}</p>
      </div>
    ),
  },
  {
    id: 'contact',
    title: t('policies.cookiePolicy.contact'),
    content: (
      <div className="text-base font-normal text-white">
        <p>{t('policies.cookiePolicy.contactDescription')}</p>
      </div>
    ),
  },
];

const CookiePolicy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="size-full">
      <NavBar />
      <PageWithTOC
        title={t('policies.cookiePolicy.title')}
        subtitle={t('policies.cookiePolicy.lastUpdated', { date: '2025/08/04' })}
        sections={getCookiePolicySections(t)}
      />
      {/* <Signature className="fixed bottom-[244px] right-[120px]" /> */}
    </div>
  );
};

export default CookiePolicy;